<div class="form" [formGroup]="form()">
  <fu-simple-input
    [useOutlineLabel]="false"
    formControlName="walletAddress"
    [label]="'withdrawal.advcash.walletAddress.label' | translate"
    [placeholder]="'withdrawal.advcash.walletAddress.placeholder' | translate"
  />
</div>
